/**
 * Internal dependencies
 */
export { LegacyAdapter as ColorPicker } from './legacy-adapter';